import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcTableConfig, OverlayRef, SortHelperDataInterface} from 'exc-controls';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcTab} from 'exc-tab';
import {DealerDetailsComponent} from '../../dealer-details/dealer-details.component';
import {ExcSort, FilterSortService} from '../../filter-sort-service.service';
import {ActivatedRoute} from '@angular/router';
import {ProviderDealerDetailsComponent} from '../provider-dealer-details/provider-dealer-details.component';
import {ModalProviderEditAuditComponent} from '../../modals/modal-provider-edit-audit/modal-provider-edit-audit.component';
import {ModalEditDealerComponent} from '../../modals/modal-edit-dealer/modal-edit-dealer.component';
import {ExcSigninService} from 'exc-signin';

@Component({
  selector: 'app-provider-dealer-list',
  templateUrl: './provider-dealer-list.component.html',
  styles: []
})
export class ProviderDealerListComponent extends  ExcTranslation implements OnInit {
  @ViewChild('filterMenu') filterMenu;
  dealerTableConfig: ExcTableConfig = new ExcTableConfig();
  allData: {Dealer: []};
  dealerData: any;
  searchValue = '';
  sDealerName = '';
  sDealerID = '';
  sDealerObjectAudit = '0' ;
  sDealerDocumentAudit = '0' ;
  sDealerDocumentTreat = '0' ;
  clients: any[];
  selectedClient = '0';
  sDealerRating = '';
  lstSort: ExcSort[] = [];
  isFirstCall = true;
  addMore = false;
  objectTypes: number[] = [];
  docTypes: number[] = [];
  documentType: number[] = [];

  constructor(private excRest: ExcRestService, private excDss: DefaultSettingsService, private excFss: FilterSortService , private excSec: ExcSigninService) {
    super();
    const _self = this;
    for (let i = 1 ; i <= 6 ; i++) {
      _self.docTypes.push(i);
    }
    for (let i = 1 ; i <= 21 ; i++) {
      _self.objectTypes.push(i);
    }
    for (let i = 1 ; i <= 21 ; i++) {
      _self.documentType.push(i);
    }

    ExcCoreModule.on('P_Dealer_Reload', () => {
      _self.initialLoad();
    });
   if (_self.excSec.isFeatured('PRV_DLR_CU')) {
      _self.dealerTableConfig.OnAdd = () => {
        _self.addDealer();
      };
   }
    _self.dealerTableConfig.OnRefresh = () => {
      _self.initialLoad();
    };
    _self.dealerTableConfig.OnPageChanged = (pageNo) => {
      _self.dealerTableConfig.paging.pageNo = pageNo;
      _self.initialLoad();
    };
    _self.dealerTableConfig.OnSearch = (searchValue) => {
      _self.searchValue = searchValue;
      _self.initialLoad();
    };
    _self.dealerTableConfig.OnFilterClick = (event?) => _self.filterMenu.toggle(event);
    _self.dealerTableConfig.OnFilter = () => {
    };
  }
  ngOnInit() {
    const _self = this;
    _self.setSortData();
    _self.initialLoad();
  }
  initialLoad () {
   const _self = this;
    let metainfo = _self.dealerTableConfig.GetMetaInfo();
    const filter = _self.dealerTableConfig.MetaInfo.dataFilter;
    metainfo =  _self.excFss.ApplyFilter(metainfo, [], _self.lstSort);
    _self.dealerTableConfig.MetaInfo.dataFilter = filter;
    _self.dealerTableConfig.MetaInfo.dataSort = metainfo.dataSort;
   const url = _self.excRest.computeUrl('Provider_DealerR_List', {fts: _self.searchValue == null ? '' : this.searchValue});
   const mi = _self.dealerTableConfig.GetMetaInfo();
   _self.dealerTableConfig.isLoading = true;
   _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
     if (ret) {
       _self.allData = ret.data;
       _self.dealerData = ret.data.Dealer;
       if (!_self.clients) {
         _self.clients = ret.data.Client;
       }
       _self.dealerTableConfig.paging = ret.paging.Dealer;
     /*  _self.pagings = ret.paging;
       _self.data = _self.levels['Dealer' + this.level];
       _self.dealerTableConfig.paging = _self.pagings['Dealer' + this.level];
       _self.ratings = ret.data.Ratings;*/
       _self.dealerTableConfig.isLoading = false;
     }
   });
  }
  setSortData() {
    const _self = this;
    _self.lstSort = [
        new ExcSort('DealerName', 0, 'ProviderDealerListComponent.DealerName', 0)
      , new ExcSort('DealerObjectAudit', 0, 'ProviderDealerListComponent.DealerObjectAudit', 0)
      , new ExcSort('DealerDocumentTreat', 0, 'ProviderDealerListComponent.DealerDocumentTreat', 0)
      , new ExcSort('DealerDocumentAudit', 0, 'ProviderDealerListComponent.DealerDocumentAudit', 0)
      , new ExcSort('DealerRating', 0, 'ProviderDealerListComponent.DealerRating', 0)
    ];
    for (const x of _self.lstSort) {
      if (x !== undefined) {
        x.Container = _self.lstSort;
      }
    }
  }
  applyFilter() {
    const _self = this;
    const filterValuesClient = [];
    const mi = _self.dealerTableConfig.MetaInfo;
    if (_self.selectedClient !== '0') {
      mi.dataFilter.ClientID = {value: _self.selectedClient, operator: '='};
    } else {
      delete  mi.dataFilter['ClientID'];
    }
    if (_self.sDealerName !== '') {
      mi.dataFilter.DealerName = {value: _self.sDealerName, operator: 'LIKE'};
    } else {
      delete  mi.dataFilter['DealerName'];
    }
    if (_self.sDealerObjectAudit !== '0') {
      mi.dataFilter.DealerObjectAudit = {value: _self.sDealerObjectAudit, operator: '='};
    } else {
      delete  mi.dataFilter['DealerObjectAudit'];
    }
      if (_self.sDealerDocumentAudit) {
        mi.dataFilter.DealerDocumentAudit = {value: _self.sDealerDocumentAudit, operator: '='};
      } else {
        delete mi.dataFilter['DealerDocumentAudit'];
      }
      if (_self.sDealerDocumentTreat !== '0') {
        mi.dataFilter.DealerDocumentTreat = {value: _self.sDealerDocumentTreat, operator: '='};
      } else {
        delete  mi.dataFilter['DealerDocumentTreat'];
      }
      if (_self.sDealerRating !== '') {
        mi.dataFilter.DealerRating = {value: _self.sDealerRating, operator: '='};
      } else {
        delete  mi.dataFilter['DealerRating'];
      }
    _self.filterMenu.hide();
    _self.initialLoad();
  }
  resetFilter() {
    const _self = this;
    _self.resetFilterElement();
    const mi = _self.dealerTableConfig.MetaInfo;
    mi.dataFilter = {};
    mi.dataFSort = {};
    _self.filterMenu.hide();
    _self.initialLoad();
  }

  resetFilterElement () {
    const _self = this;
    _self.sDealerName = '' ;
    _self.selectedClient = '0';
    _self.sDealerID = '' ;
    _self.sDealerRating = '' ;
    _self.sDealerDocumentTreat = null;
    _self.sDealerObjectAudit = null;
    _self.sDealerDocumentAudit  = null;
    if (_self.lstSort && _self.lstSort !== null) {
      _self.lstSort.forEach((obj) => { obj.Value = obj.Default; });
    }
  }
  showDealerDetails (data) {
    new ExcTab(data.DealerName , ProviderDealerDetailsComponent, {
      DealerID: data.DealerID,
    }, data.DealerID, {Unique: true}, true).Open();
  }
  addDealer( data: any = null) {
    const _self = this;
    ExcCoreModule.showModal(ModalEditDealerComponent, null, 'xl',
      { data: data, clients: _self.clients, IsFirstCall: _self.isFirstCall, AddMore: _self.addMore}, false, null).subscribe(ret => {
      if (ret.proceed === true) {
        _self.isFirstCall = false;
        _self.addMore = ret.addMore;
        if (ret.dealer) {
          if (data === null ) {
            const url = _self.excRest.computeUrl('Provider_DealerC');
            _self.excRest.post(url, ret.dealer
              , {}).subscribe(obj => {
              if (obj) {
                if (_self.addMore === true) {
                  _self.addDealer();
                }
                _self.initialLoad();
              }
            });
          }
        }
       } else {
        if (ret.IsFirstCall === false) {
          _self.initialLoad();
        }
      }
    });
  }
}
